var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.fetchingDrm)?_c('drm-form',{attrs:{"drm-settings":_vm.drmSettings},on:{"submit":_vm.saveRawKey}}):_c('loading-page')}
var staticRenderFns = []

export { render, staticRenderFns }